<template>
  <div>
    <div class="my-3">
      문항수:
      <input type="number" class="input-underline" v-model="nums" style="width:40px"/>
      <mdb-btn class="m-0 p-1 mr-3" v-if="this.pretest" @click="onModify">문제수 조정</mdb-btn>
      <mdb-btn class="m-0 p-1 mr-3" v-else @click="onGenerate">문제 생성</mdb-btn>
      <save-btn-sm class="mr-2" @click="onSave">저장</save-btn-sm>
      <delete-btn-sm @click="onDelete">삭제</delete-btn-sm>
    </div>
    <div v-if="pretest">
      <div v-for="(q, i) in pretest.questions" :key="i">
        <question-edit  :question="q">
          <div class="bolder pr-1 blue lighten-5 p-1">문제 {{i+1}}
            <delete-btn-xs @click="onDeleteQuestion(i)"/>
            능력단위 코드(또는 과목명 ) :
            <input v-model="q.code" class="w-50 input-underline">
          </div>
        </question-edit>
      </div>
    </div>
    <div class="my-3"  v-if="pretest && pretest.questions.length > 1">
      <save-btn-sm class="mr-2" @click="onSave">저장</save-btn-sm>
      <delete-btn-sm @click="onDelete">삭제</delete-btn-sm>
    </div>
  </div>
</template>
<script>
import { mdbTabs } from 'mdbvue'
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import PreTest from '@/models/test/PreTest'
import QuestionEdit from '../../../../components/test/QuestionEdit.vue'
export default {
  name: 'StaffOpenTrainingPreTest',
  components: { QuestionEdit },
  data () {
    return {
      TAG: 'StaffOpenTrainingPreTest >>',
      pretest: undefined,
      nums: 0
    }
  },
  computed: {
    training () { return this.$route.query.training },
    active () { return parseInt(this.$route.query.active) || 0 }
  },
  methods: {
    async load () {
      this.pretest = await PreTest.get({ training: this.training })
      if (this.pretest && this.pretest.questions) {
        this.nums = this.pretest.questions.length
      }
    },
    async onSave () {
      if (!confirm('저장할까요?')) return
      // 배점 계산
      const count = this.pretest.questions.length
      const score = parseFloat((100 / count).toFixed(2))
      this.pretest.questions.forEach(q => { q.assignScore = score })
      this.pretest = await this.pretest.save()
    },
    async onDelete () {
      if (!confirm('문제 전체를 삭제할까요?')) return
      await this.pretest.delete()
      this.pretest = undefined
    },
    onDeleteQuestion (ix) {
      if (!confirm('해당 문항을 삭제할까요?')) return
      this.pretest.questions.splice(ix, 1)
    },
    onGenerate () {
      if (!confirm(this.nums + '개의 문제를 생성할까요?')) return
      this.pretest = PreTest.create(this.training, this.nums)
      this.pretest.questions = []
      for (let i = 0; i < this.nums; i++) {
        this.pretest.questions.push({ })
      }
    },
    onModify () {
      if (!confirm(this.nums + '개로 문항 수를 조정할까요?')) return
      if (this.nums > this.pretest.questions.length) { // 늘리기
        for (let i = this.pretest.questions.length; i < this.nums; i++) {
          this.pretest.questions.push({ })
        }
      } else { // 줄이기
        const count = this.pretest.questions.length - this.nums
        this.pretest.questions.splice(this.nums, count)
      }
    }
  },
  created () {
    this.load()
  }
}
</script>
